import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Users, Heart, Award, GraduationCap, Sparkles } from 'lucide-react';
import MetricCard from '../components/MetricCard';

const mockData = {
  diversityData: [
    { name: 'Male', value: 60 },
    { name: 'Female', value: 35 },
    { name: 'Non-binary', value: 5 },
  ],
  employeeSatisfaction: [
    { category: 'Work-Life Balance', score: 7.5 },
    { category: 'Career Growth', score: 6.8 },
    { category: 'Compensation', score: 7.2 },
    { category: 'Company Culture', score: 8.1 },
  ],
  diversityTrend: [
    { year: 2018, diversity: 65 },
    { year: 2019, diversity: 68 },
    { year: 2020, diversity: 70 },
    { year: 2021, diversity: 72 },
    { year: 2022, diversity: 75 },
  ],
};

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const Social = () => (
  <div className="p-6">
    <h1 className="text-3xl font-bold mb-6">Social Responsibility</h1>
   
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <MetricCard title="Employee Satisfaction" value="8.1/10" trend={0.5} icon={Heart} />
      <MetricCard title="Diversity Score" value="75%" trend={3} icon={Users} />
      <MetricCard title="Training Hours" value="40 hrs/emp" trend={10} icon={GraduationCap} />
      <MetricCard title="Community Impact" value="$500K" trend={25} icon={Award} />
    </div>

    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Workforce Diversity</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={mockData.diversityData}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            >
              {mockData.diversityData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>

    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Diversity Score Trend</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={mockData.diversityTrend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis domain={[60, 80]} />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="diversity" stroke="#8884d8" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>

    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Employee Satisfaction Scores</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={mockData.employeeSatisfaction}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" />
            <YAxis domain={[0, 10]} />
            <Tooltip />
            <Legend />
            <Bar dataKey="score" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>

    <Card className="mt-6">
      <CardHeader>
        <CardTitle className="flex items-center">
          <Sparkles className="mr-2 h-5 w-5 text-yellow-500" />
          AI-Generated Social Insights
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="list-disc pl-5 space-y-2">
          <li>Employee satisfaction has increased by 5% over the last quarter, primarily due to improvements in work-life balance.</li>
          <li>The diversity score shows a positive trend, but there's room for improvement in leadership positions.</li>
          <li>Increasing training hours has shown a direct correlation with employee retention rates.</li>
          <li>Community impact initiatives have led to a 10% increase in positive brand perception.</li>
        </ul>
      </CardContent>
    </Card>
  </div>
);

export default Social;